
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle.jsx";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";


const locationsPageStyle = {
  ...sweetAlertStyle,
  ...extendedTablesStyle,
  ...regularFormsStyle,
  ...extendedFormsStyle,
}

export default locationsPageStyle;


// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-pro-react/views/locationsPageStyle.jsx